import { createSlice } from "@reduxjs/toolkit";

const bookCartSlice = createSlice({
    name: "bookCartReducer",
    initialState: {
        bookCartCount: 0,
        bookCartData: {}
    },
    reducers: {
        incrementBookCart(state, action) {
            state.bookCartCount = state.bookCartCount + action.payload;
        },
        decrementBookCart(state, action) {
            state.bookCartCount = state.bookCartCount - action.payload;
        },
        setBookCartValue(state, action) {
            state.bookCartCount = action.payload;
        },
        setBookCartData(state, action) {
            state.bookCartData = action.payload;
        },
        clearBookCart(state, action) {
            state.bookCartData = {};
        }
    }
});

export const bookCartAction = bookCartSlice.actions;

export default bookCartSlice;